var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 mb-3 motivationstext"},[_c('h2',{staticClass:"mutmach-text"},[_vm._v(_vm._s(_vm.calcUmsatzText()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }